import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BudgetStructure } from '../../../../core/services/dataBean/EntityCatalog';
import { _BudgetSource } from '../../../../core/services/dataBean/EntityCatalogVdos';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectBudgetStructure = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_BudgetStructure);
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector)
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }


    const getLista = () => {

        instance.getBudgetStructureList(null).then(
            (resp: any) => {
                if (resp) {

                    setLista(resp)
                    if (resp.length > 0) {
                        setValue(resp[0].DataBeanProperties.Value);
                    }

                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Estructura de Rubro Presupuestal"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{`${item.DataBeanProperties.Property ?? ""}`}</option>
                        )
                    })
                }
            </select>
        </>
    )
}